/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PostUsersResetPasswordVerify200,
  PostUsersResetPasswordVerify400,
  PostUsersResetPasswordVerifyMutationRequest,
  PostUsersResetPasswordVerifyMutationResponse,
} from '../entities/PostUsersResetPasswordVerify'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { userResetPasswordVerifyRequestSchema } from './userResetPasswordVerifyRequestSchema'
import { userResetPasswordVerifyResponseSchema } from './userResetPasswordVerifyResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const postUsersResetPasswordVerify200Schema = z.lazy(() => userResetPasswordVerifyResponseSchema) as unknown as ToZod<PostUsersResetPasswordVerify200>

/**
 * @description Bad Request
 */
export const postUsersResetPasswordVerify400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostUsersResetPasswordVerify400>

/**
 * @description Подтверждение восстановления пароля
 */
export const postUsersResetPasswordVerifyMutationRequestSchema = z.lazy(
  () => userResetPasswordVerifyRequestSchema,
) as unknown as ToZod<PostUsersResetPasswordVerifyMutationRequest>

export const postUsersResetPasswordVerifyMutationResponseSchema = z.lazy(
  () => postUsersResetPasswordVerify200Schema,
) as unknown as ToZod<PostUsersResetPasswordVerifyMutationResponse>